import axios from 'axios'

export default {
    namespaced: true,
    state: {
        config: {
            url: 'https://keycloak.dundeeandangus.ac.uk',
            realm: null,
            clientId: null,
        },
        instance: null,
    },
    mutations: {
        SET_URL(state, payload) {
            state.config.url = payload;
        },
        SET_REALM(state, payload) {
            state.config.realm = payload;
        },
        SET_CLIENTID(state, payload) {
            state.config.clientId = payload;
        },
        SET_INSTANCE(state, payload) {
            state.instance = payload;
        },
    },
    actions: {
        SetKeycloakURL({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/auth/url`)
                    .then(response => {
                        if (response.status == 200) {
                            commit('SET_URL', response.data);
                            resolve();
                        }
                    }).catch(error => reject(`SetKeycloakURL: ${error.message}`));
            });
        },
        SetKeycloakRealm({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/auth/realm`)
                    .then(response => {
                        if (response.status == 200) {
                            commit('SET_REALM', response.data);
                            resolve();
                        }
                    }).catch(error => reject(`SetKeycloakRealm: ${error.message}`));
            });
        },
        SetKeycloakClientID({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/auth/clientid`)
                    .then(response => {
                        if (response.status == 200) {
                            commit('SET_CLIENTID', response.data);
                            resolve();
                        }
                    }).catch(error => reject(`SetKeycloakClientID: ${error.message}`));
            });
        },
        SetKeycloakInstance({ commit }, obj) {
            commit('SET_INSTANCE', obj);
        },
    },
    getters: {
        Config(state) {
            return state.config;
        },
        Instance(state) {
            return state.instance;
        },
    },
}
